/**
 * Evidence Pack Downloader
 * Generate and download audit/compliance evidence packs
 */
import React, { useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const EvidencePackDownloader = () => {
  const [packType, setPackType] = useState('plan_audit');
  const [dateRange, setDateRange] = useState({
    from_date: '',
    to_date: ''
  });
  const [generating, setGenerating] = useState(false);

  const generatePack = async () => {
    setGenerating(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${API_URL}/api/evidence-packs/generate`,
        {
          pack_type: packType,
          from_date: dateRange.from_date,
          to_date: dateRange.to_date
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      alert('Evidence pack generated! Check your downloads.');
    } catch (error) {
      alert('Error: ' + (error.response?.data?.detail || error.message));
    } finally {
      setGenerating(false);
    }
  };

  return (
    <div className="p-8 max-w-4xl mx-auto">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Evidence Pack Generator</h1>
        <p className="text-gray-600 mt-1">Generate compliance and audit documentation</p>
      </div>

      <div className="bg-white rounded-lg shadow-lg p-8">
        <div className="space-y-6">
          <div>
            <label className="block text-sm font-medium mb-2">Pack Type</label>
            <select
              value={packType}
              onChange={(e) => setPackType(e.target.value)}
              className="w-full border rounded-lg px-4 py-2"
            >
              <option value="plan_audit">Plan Audit Trail</option>
              <option value="review_audit">Review Audit Trail</option>
              <option value="approval_audit">Approval Audit Trail</option>
              <option value="full_compliance">Full Compliance Pack</option>
              <option value="donor_audit">Donor Audit Pack</option>
              <option value="system_config">System Configuration</option>
            </select>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-2">From Date</label>
              <input
                type="date"
                value={dateRange.from_date}
                onChange={(e) => setDateRange({...dateRange, from_date: e.target.value})}
                className="w-full border rounded-lg px-4 py-2"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-2">To Date</label>
              <input
                type="date"
                value={dateRange.to_date}
                onChange={(e) => setDateRange({...dateRange, to_date: e.target.value})}
                className="w-full border rounded-lg px-4 py-2"
              />
            </div>
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <h3 className="font-bold text-blue-900 mb-2">📦 Pack Will Include:</h3>
            <ul className="text-sm text-blue-800 space-y-1">
              <li>• Audit logs (CSV)</li>
              <li>• Version history (PDF)</li>
              <li>• Approval trails (PDF)</li>
              <li>• Status history (PDF)</li>
              <li>• User actions log (CSV)</li>
              <li>• System configuration snapshot (JSON)</li>
            </ul>
          </div>

          <button
            onClick={generatePack}
            disabled={generating}
            className="w-full bg-green-600 text-white py-3 rounded-lg hover:bg-green-700 disabled:bg-gray-300 font-medium text-lg"
          >
            {generating ? '🔄 Generating Evidence Pack...' : '📦 Generate Evidence Pack'}
          </button>
        </div>
      </div>

      <div className="mt-6 bg-yellow-50 border border-yellow-200 rounded-lg p-4">
        <p className="text-sm text-yellow-800">
          ℹ️ Evidence packs are digitally signed and tamper-proof. 
          They expire after 90 days. Generate new packs as needed for audits.
        </p>
      </div>
    </div>
  );
};

export default EvidencePackDownloader;